import {generateAction, RequestTypes} from "./Util";
import * as api from "../../services/Api";

export const GET_USERS = new RequestTypes("USERS");
export const GET_MANAGED_USER = new RequestTypes("MANAGED_USER");
export const CREATE_USER = new RequestTypes("CREATE_USER");
export const UPDATE_USER = new RequestTypes("UPDATE_USER");

export const getUsers= () => {
  return generateAction(GET_USERS, () =>
    api.getUsers()
  );
};

export const getUserById = (id: string) => generateAction(GET_MANAGED_USER, () => api.getUserById(id));
export const createUser = (user: any) => generateAction(CREATE_USER, () => api.createUser(user));
export const updateUser = (user: any) => generateAction(UPDATE_USER, () => api.updateUser(user));
